import React from 'react';
import { 
  Box, 
  Typography, 
  Container, 
  Paper,
  Button
} from '@mui/material';
import { Star as StarIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const TestimonialsSection = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: 'grey.50' }}>
      <Container maxWidth="lg">
        <Box textAlign="center" mb={6}>
          <Typography
            variant="h2"
            fontWeight={700}
            mb={2}
            sx={{ fontSize: { xs: '2rem', md: '3rem' } }}
          >
            What Our Customers Say
          </Typography>
          <Typography
            variant="h6"
            color="text.secondary"
            sx={{ maxWidth: 560, mx: 'auto', lineHeight: 1.6 }}
          >
            We're just getting started. Reviews will appear here after customers complete their first move.
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Paper
            elevation={0}
            sx={{
              p: 6,
              maxWidth: 480,
              width: '100%',
              borderRadius: 3,
              border: '2px dashed',
              borderColor: 'grey.300',
              textAlign: 'center',
              bgcolor: 'white',
            }}
          >
            <StarIcon sx={{ fontSize: 56, color: 'grey.300', mb: 2 }} />
            <Typography variant="h6" fontWeight={700} color="text.secondary" mb={1}>
              No reviews yet
            </Typography>
            <Typography variant="body2" color="text.disabled" mb={3}>
              Your review could be the very first one on Movd.
            </Typography>
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate('/')}
              sx={{ textTransform: 'none', fontWeight: 700, borderRadius: 2 }}
            >
              Get My Free Quote
            </Button>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
};

export default TestimonialsSection;